import type { ChatImage, GalleryState } from '@/types/chat';

export class HelpAgentGalleryController {
  private gallery: GalleryState | null = null;

  get state(): GalleryState | null {
    if (!this.gallery) {
      return null;
    }

    return {
      images: [...this.gallery.images],
      currentIndex: this.gallery.currentIndex,
    };
  }

  open(images: readonly ChatImage[], startIndex: number): GalleryState | null {
    if (images.length === 0) {
      this.gallery = null;
      return null;
    }

    const boundedIndex = Math.min(Math.max(startIndex, 0), images.length - 1);
    this.gallery = {
      images: [...images],
      currentIndex: boundedIndex,
    };

    return this.state;
  }

  shift(delta: number): GalleryState | null {
    if (!this.gallery || this.gallery.images.length === 0) {
      return null;
    }

    const total = this.gallery.images.length;
    const nextIndex = (this.gallery.currentIndex + delta + total) % total;
    this.gallery = {
      ...this.gallery,
      currentIndex: nextIndex,
    };

    return this.state;
  }

  close(): null {
    this.gallery = null;
    return null;
  }

  reset(): void {
    this.gallery = null;
  }
}
